import React, { FC, useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import "./sortableContentList.scss";
import CardMenu from "../CardMenu";
import DeleteAlert from "../../DeleteAlert";
import videoIcon from "../../../../assets/icons/video-chapter-icon.svg";
import pdfIcon from "../../../../assets/icons/pdf-chapter-icon.svg";
import dragTrigger from "../../../../assets/icons/drag-trigger.svg";
import placeholderIcon from "../../../../assets/placeholder/courseLogoPlaceholder.png"
import ContentEditForm from "../ContentEditForm";
import ChapterContentViewer from "../ChapterContentViewer";
import ChapterContentService from "../../../../services/CourseServices/ChapterService/chapterContent.service";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamContentService } from "../../../../services/ExamService/ContentService/content.service";

interface SortableContentListProps extends RouteComponentProps {
  list: any;
  setList: any;
  menuText: string;
  refreshList: Function;
}

const SortableContentList: FC<SortableContentListProps> = (props) => {
  const { list, setList, menuText, refreshList } = props;
    const [urlParams, setUrlParams] = useState<any>()
  const [currentContent, setCurrentContent] = useState<any>();
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [showContent, setShowContent] = useState<boolean>(false);

    useEffect(() => {
        setUrlParams(props.match.params)
    },[])

  const handleDelete = () => {
    if (props.location.pathname.includes("exams") && urlParams?.subjectId) {
        ExamContentService.deleteExamContent(
            currentContent?.id,
            () => {
                refreshList();
                setDeleteVisible(false);
            },
            () => {}
        )
    } else {
      ChapterContentService.deleteChapterContent(
        currentContent?.id,
        () => {
          refreshList();
          setDeleteVisible(false);
        },
        () => {},
        () => {}
      ).then();
    }
  };

  const handleSort = (e: any) => {
    let data = {
      chaptor_content: {
        position: e.newIndex + 1,
      },
    };
    ChapterContentService.updateChapterContentPosition(
      e.item.dataset.id,
      data,
      () => {
        refreshList();
      },
      () => {
        refreshList();
      },
      () => {}
    ).then();
  };

  const handleStatusToggle = (value: boolean) => {
      if (props.location.pathname.includes("exams")){
          const data = {
              id: currentContent?.id,
              contentData:{isActive: value}
          }
          ExamContentService.updateExamContent(
              data,
              () => {
                  currentContent.isActive = !currentContent.isActive
                  refreshList();
              },
              () => {
              }
          ).then();
      }else {
          ChapterContentService.updateChapterContent(
              currentContent?.id,
              {chaptor_content: {is_active: value}},
              (chapterContent: any) => {
                  refreshList();
                  setCurrentContent(chapterContent);
              },
              () => {
              },
              () => {
              }
          ).then();
      }
  };

  return (
    <>
      <ContentEditForm
        visible={formVisible}
        setVisible={setFormVisible}
        data={currentContent}
        refreshList={refreshList}
      />
      <DeleteAlert
        contentTitle={currentContent?.displayTitle}
        contentSubject="Subject"
        contentThumbnail={currentContent?.contentLibrary?.displayPictureUrl}
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText="Content"
        handleDelete={handleDelete}
      />
      <ReactSortable list={list} setList={setList} onSort={handleSort}>
        {list.map((item: any) => (
          <div
            key={item.id}
            className="sortable__container sortable__content__container"
          >
            <div className="sortable__trigger">
              <img src={dragTrigger} alt="" />
            </div>
            <div
              className="sortable__card sortable__content__card"
              onClick={() => {
                setCurrentContent(item);
                setShowContent(true);
              }}
            >
              <div>
                <div className="sortable__thumbnail">
                  <img src={item?.contentLibrary?.displayPictureUrl || videoIcon} alt="" />
                </div>
                <div className="sortable__title sortable__content__title">
                  <div>{item?.displayTitle || item?.title}</div>
                  <div className="content__id">ID: {item?.id}</div>

                  <div className="sortable__content__info">
                    <img
                      src={
                        item?.contentLibrary?.contentType === "video"
                          ? videoIcon
                          : pdfIcon
                      }
                      alt=""
                    />
                    <span>
                      {item?.contentLibrary?.contentLength}{" "}
                      {item?.contentLibrary?.contentType === "video"
                        ? "mins"
                        : "pages"}
                    </span>
                  </div>

                </div>
                <div
                  className="sortable__menu-trigger sortable__content__menu"
                  onClick={(event) => {
                    event.stopPropagation();
                    setCurrentContent(item);
                  }}
                >
                  <CardMenu
                    menuText={menuText}
                    handleEdit={setFormVisible}
                    handleDelete={setDeleteVisible}
                  />
                </div>
              </div>
              <div className="sortable__status">
                <span
                  className={`sortable__status__indicator ${
                    item.isActive ? "active" : "inactive"
                  }`}
                />
                {item.isActive ? "Active" : "Inactive"}
              </div>
            </div>
          </div>
        ))}
      </ReactSortable>
      <ChapterContentViewer
        content={currentContent}
        visible={showContent}
        setVisible={setShowContent}
        handleStatusToggle={handleStatusToggle}
      />
    </>
  );
};

export default withRouter(SortableContentList);
